export default {
    //登录
    setToken: token => {
        localStorage.setItem("token", token);
    },
    getToken: () => {
        return localStorage.getItem("token");
    },
    removeToken: () => {
        localStorage.removeItem("token");
    },
    
    // 用户访问网页次数(visit view)
    setVV: (times) => {
        localStorage.setItem("VV", times);
    },
    getVV: () => {
        return localStorage.getItem("VV");
    },
    removeVV: () => {
        localStorage.removeItem("VV");
    },
};



// WEBPACK FOOTER //
// ./src/common/storage.js